import React from 'react';

function Landing() {
  const role = localStorage.getItem('role') || 'User';

  return (
    <div className="min-h-screen bg-gray-950 text-zinc-100 p-8 space-y-12">
      {/* Welcome Heading - white text */}
      <h1 className="text-4xl font-bold tracking-tight text-white">
        Welcome to Stalwart Electric Portal
      </h1>

      {/* Personalized subheading */}
      <div className="text-xl text-zinc-300">
        Hello, <span className="font-semibold text-indigo-400 capitalize">{role}</span>!
      </div>

      {/* Quick overview / dashboard teaser */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800/50 shadow-lg">
          <h2 className="text-xl font-semibold text-zinc-100 mb-2">Quick Stats</h2>
          <p className="text-zinc-400">Inventory: 1,245 items • Active Projects: 8 • Pending Invoices: 3</p>
        </div>

        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800/50 shadow-lg">
          <h2 className="text-xl font-semibold text-zinc-100 mb-2">Recent Activity</h2>
          <ul className="space-y-2 text-zinc-300">
            <li>• New customer added: Acme Builders</li>
            <li>• Invoice created: #INV-045</li>
            <li>• Log entry: Equipment check completed</li>
          </ul>
        </div>

        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800/50 shadow-lg">
          <h2 className="text-xl font-semibold text-zinc-100 mb-2">Get Started</h2>
          <p className="text-zinc-400">
            Use the sidebar to navigate: Inventory, Customers, Billing, or Settings.
          </p>
        </div>
      </div>

      {/* Optional: Add more sections like recent logs, charts, etc. */}
    </div>
  );
}

export default Landing;